import { ConversationRunContainer, IConversationRunContainer, SelectorResult } from './ConversationRunContainer';
import { IContainerSelectorFactory } from './IContainerSelectorFactory';

export class TextContainer
    extends ConversationRunContainer<string>
    implements IConversationRunContainer<string>
{
    isAppendable(): boolean {
        return true;
    }
    selectFromFactory<T extends IContainerSelectorFactory<any>>(selectorFactory: T): SelectorResult<T> {
        return selectorFactory.getText();
    }

    getEntityName(): string {
      return 'TextContainer';
    }

    appendData(data: string): void {
        const currentData = this.data.get();
        this.data.set(currentData + data);
    }
}